export const sections = [
  "home",
  "about",
  "work",
  "skills",
  "testimonial",
  "contact",
];
